import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Welcome from "@/pages/Welcome";
import Intake from "@/pages/Intake";
import Dashboard from "@/pages/Dashboard";
import KYC from "@/pages/KYC";
import Accreditation from "@/pages/Accreditation";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-10 h-10 border-2 border-emerald-500/30 border-t-emerald-400 rounded-full animate-spin" />
  </div>
);

const Protected = ({ children, requireIntake = true }) => {
  const { member, loading } = useAuth();
  if (loading) return <Loader />;
  if (!member) return <Navigate to="/" replace />;
  if (requireIntake && !member.intake_completed) return <Navigate to="/intake" replace />;
  return children;
};

const HomeRoute = () => {
  const { member, loading } = useAuth();
  if (loading) return <Loader />;
  if (member) return <Navigate to={member.intake_completed ? "/dashboard" : "/intake"} replace />;
  return <Welcome />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/intake" element={<Protected requireIntake={false}><Intake /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/kyc" element={<Protected><KYC /></Protected>} />
      <Route path="/accreditation" element={<Protected><Accreditation /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
